export {
  default,
  isRichTextEmpty,
  type WangRichTextProps,
} from './WangRichText';
